export class Site {
  public id: string;
  public organizationId: string;
  public name: string;
}
